module.exports = require('./helpers/bundle-url').getBundleURL('2DEgY') + "logo.c51670a8.svg";